<section class="section-products" *ngIf="products.length > 0">
    <div class="container">
        <div class="col-12 text-center">
            <input type="text" placeholder="Search Products" [ngModel]="searchModel" (ngModelChange)="updateSearchModel($event)">
        </div>
      <div class="row text-left">
        <div class="col-md-12 col-lg-12 mb-4 mt-5">
          <div class="header">
            <h2>{{ routerPath }} Products</h2>
          </div>
        </div>
      </div>
      <div class="row">
        <!-- Single Product -->
        <div class="col-md-6 col-lg-4 col-xl-3" *ngFor="let product of products | listFilter: searchModel">
          <div id="product-1" class="single-product">
            <div class="part-1">
              <img src="{{ product.image }}" alt="" class="img-fluid">
              <ul>
                <li><a (click)="addFavourite(product)"><i class="fa fa-heart"></i></a></li>
              </ul>
              <h4 class="new">{{ product.category }}</h4>
            </div>
            <div class="part-2">
              <h3 class="product-title">{{ product.title }}</h3>
              <h4 class="product-price price">₹{{ product.price}}</h4>
  
  
              <div class="d-flex justify-content-between align-items-center">
                <div class="">
                  <h4 class="product-price rating mb-0"><i class="fa fa-star" aria-hidden="true"></i>
                    {{product.rating.rate}}</h4>
                  <h4 class="product-price count mb-0">({{product.rating.count}})</h4>
                </div>
                <button class="btn btn-sm py-0" mat-button [routerLink]="['/product' , product.id]">Details</button>
              </div>
            </div>
          </div>
        </div>
        <div class="" *ngIf="( products | listFilter: searchModel) as result">
            <p class="text-center" *ngIf="result.length === 0">No Result Found</p>  
        </div>
      </div>

    </div>
  </section>
  
  <div *ngIf="products.length == 0">
    <ngx-spinner size="medium" type="ball-fussion"></ngx-spinner>
  </div>
  